/**
 * Ofertas do funil (dados fixos, sem consulta à API).
 *
 * Usado por:
 *   - /cta                 -> CTA_OFFER (src/pages/Cta.jsx)
 *   - /obrigado e /upsell  -> UPSELL_PRODUCTS (src/pages/UpsellFirewall.jsx)
 *   - /planos e /plans-sell -> PLANS (src/pages/Planos.jsx)
 *
 * Para trocar um link de checkout, edite apenas CHECKOUT_URLS.
 * Origem dos dados: seeds do backend (prisma/seed.js e scripts/seed-plans-sell.js).
 */

export const CHECKOUT_URLS = {
  // Oferta principal (/cta) - Pink Stalker R$ 27
  main: 'https://go.perfectpay.com.br/PPU38CQH4HE',

  // Upsell pos-compra (/obrigado e /upsell) - Firewall R$ 47
  firewall: 'https://go.perfectpay.com.br/PPU38CQH4HH',

  // Planos (/planos)
  gold: 'https://go.perfectpay.com.br/PPU38CQH4HN',
  diamond: 'https://go.perfectpay.com.br/PPU38CQH4HT',
  premium: 'https://go.perfectpay.com.br/PPU38CQH4I2',
};

// Oferta principal exibida em /cta
export const CTA_OFFER = {
  price: '27,00',
  oldPrice: '297,90',
  checkoutUrl: CHECKOUT_URLS.main,
};

export const DEFAULT_UPSELL_SLUG = 'firewall-protecao';

// Chave = slug, que pode vir pela URL: /upsell?product=<slug>
export const UPSELL_PRODUCTS = {
  'firewall-protecao': {
    id: 'firewall-protecao',
    slug: 'firewall-protecao',
    name: 'Firewall de Proteção Avançada',
    shortDescription: 'Proteção máxima para suas investigações',
    priceDisplay: 'R$ 47,00',
    originalPrice: 'R$ 297,00',
    checkoutUrl: CHECKOUT_URLS.firewall,
    buttonText: 'Ativar Firewall Agora',
  },
};

export const PLANS = [
  {
    id: 'gold',
    slug: 'gold',
    name: 'Gold',
    originalPrice: null,
    currentPrice: 67.0,
    checkoutUrl: CHECKOUT_URLS.gold,
    featuresIncluded: [
      'Acesso vitalício (Acesso de 7 dias)',
      'Busca de apenas 1 perfil',
      'Monitoramento apenas do Insta',
      'Suporte em horário comercial pelo email',
    ],
    featuresExcluded: [
      'Localização em Tempo Real',
      'Galeria de Fotos (incluindo fotos apagadas)',
      'BRINDE: Espião Completo do Facebook',
      'BRINDE: Espião Completo do Messenger',
    ],
    badge: null,
    buttonText: 'Selecionar',
    slotsAvailable: null,
    paymentType: 'Pagamento único',
    colorTheme: 'gold',
  },
  {
    id: 'diamond',
    slug: 'diamond',
    name: 'Diamond',
    originalPrice: 132.0,
    currentPrice: 97.0,
    checkoutUrl: CHECKOUT_URLS.diamond,
    featuresIncluded: [
      'Acesso vitalício (Acesso de 1 mês)',
      'Busca de 3 perfis',
      'Monitoramento Completo',
      'Suporte 24h pelo WhatsApp',
      'Localização em Tempo Real',
      'Galeria de Fotos (incluindo fotos apagadas)',
    ],
    featuresExcluded: [
      'BRINDE: Espião Completo do Facebook',
      'BRINDE: Espião Completo do Messenger',
    ],
    badge: 'Mais Vendido',
    buttonText: 'Selecionar Mais Vendido',
    slotsAvailable: 71,
    paymentType: 'Pagamento único',
    colorTheme: 'blue',
  },
  {
    id: 'premium',
    slug: 'premium',
    name: 'Premium',
    originalPrice: 254.0,
    currentPrice: 127.0,
    checkoutUrl: CHECKOUT_URLS.premium,
    featuresIncluded: [
      'Acesso Vitalício a Todos os Apps',
      'Busca de Perfis ILIMITADOS',
      'Monitoramento Completo',
      'Suporte 24h pelo WhatsApp',
      'Localização em Tempo Real',
      'Galeria de Fotos (incluindo fotos apagadas)',
      'BRINDE: Espião Completo do Facebook',
      'BRINDE: Espião Completo do Messenger',
    ],
    featuresExcluded: [],
    badge: 'Melhor Custo Benefício',
    buttonText: 'Selecionar Custo Benefício',
    slotsAvailable: 139,
    paymentType: 'Pagamento único',
    colorTheme: 'purple',
  },
];
